<template>
    <div id="main-container">
        <h1 id="page-title">{{ pageName }}</h1>

        <div>
            <Accordion v-model:activeIndex="state.activeAccordionIndex" @update:activeIndex="onAccordionChange">
                <AccordionTab header="POD">
                    <div>
                        <TabView class="custom-tabview" @tab-change="onTabChange" v-model:activeIndex="state.tabViewActiveIndex">
                            <TabPanel header="Sospensione Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioni('sospensioni')" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.sospensioniRichieste"
                                        :paginator="true" 
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>
                                        
                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="data_richiesta_sospensione" header="Data Richiesta Sospensione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Sospensione Lavorazione">
                                <div id="data_table-div">
                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>
                                    
                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.sospensioniLavorazione"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        :rowClass="sospensioneLavorazioneColor"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="data_sospensione_lavorazione" header="Data Sospensione Lavorazione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Sospesi">
                                <div id="data_table-div">

                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.podSospesi"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Sospensione in KO">
                                <div id="data_table-div">

                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioni('sospKO')" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.podSospKo"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                        <Column field="nota" header="Nota" style="width: 250px;" sortable>
                                            <template #body="slotProps">
                                                <span 
                                                    v-if="slotProps.data.nota" 
                                                    :title="slotProps.data.nota"
                                                    style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                >
                                                    {{ truncateText(slotProps.data.nota, 40) }}
                                                </span>
                                                <span v-else class="text-500">
                                                    Nessuna nota
                                                </span>
                                            </template>
                                        </Column>
                                        <Column header="Azioni" style="width: 120px;">
                                            <template #body="slotProps">
                                                <Button
                                                    icon="pi pi-comment"
                                                    class="p-button-sm p-button-rounded"
                                                    :class="slotProps.data.nota ? 'p-button-warning' : 'p-button-secondary'"
                                                    @click="openNoteModal(slotProps.data)"
                                                />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivazione Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioni('riattivazioni')" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.riattivazioniRichieste"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivazione Lavorazione">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable 
                                        :value="state.riattivazioniLavorazione"
                                        :paginator="true" 
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        :rowClass="riattivazioneLavorazioneColor"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="data_riattivazione_lavorazione" header="Data Riattivazione Lavorazione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivati">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable 
                                        :value="state.podRiattivati"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivazione in KO">
                                <div id="data_table-div">

                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioni('riatKO')" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.podRiatKo"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                        <Column field="nota" header="Nota" style="width: 250px;" sortable>
                                            <template #body="slotProps">
                                                <span 
                                                    v-if="slotProps.data.nota" 
                                                    :title="slotProps.data.nota"
                                                    style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                >
                                                    {{ truncateText(slotProps.data.nota, 40) }}
                                                </span>
                                                <span v-else class="text-500">
                                                    Nessuna nota
                                                </span>
                                            </template>
                                        </Column>
                                        <Column header="Azioni" style="width: 120px;">
                                            <template #body="slotProps">
                                                <Button
                                                    icon="pi pi-comment"
                                                    class="p-button-sm p-button-rounded"
                                                    :class="slotProps.data.nota ? 'p-button-warning' : 'p-button-secondary'"
                                                    @click="openNoteModal(slotProps.data)"
                                                />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivazione seguito spostamento">
                                <div id="data_table-div">

                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.podRiatSpostamento"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Costi Sospensioni">
                                <div id="data_table-div">
                                    
                                    <div class="flex align-items-center justify-content-end p-3">
                                        
                                        <Button     
                                        label="Cambia Stato" 
                                        icon="pi pi-pencil"
                                        class="p-button-sm p-button-rounded mr-2" 
                                        @click="cambiaStato()" 
                                        ></Button>

                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.podCostiSospensioni"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pod" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="numero_tentativi" header="Numero Tentativi" style="width: 200px;" sortable />
                                        <Column field="costo" header="Costo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>

                        </TabView>
                    </div>
                </AccordionTab>

                <!-- Scheda PDR -->
                <AccordionTab header="PDR">
                    <div>
                        <TabView class="custom-tabview" @tab-change="onTabChangePdr">
                            <TabPanel header="Sospensione Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioniPdr('sospensioni')" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.sospensioniRichiestePdr"
                                        :paginator="true" 
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="data_richiesta_sospensione" header="Data Richiesta Sospensione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Sospensione Lavorazione">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.sospensioniLavorazionePdr"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        :rowClass="sospensioneLavorazioneColor"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="data_sospensione_lavorazione" header="Data Sospensione Lavorazione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Sospesi">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable 
                                        :value="state.pdrSospesi"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>

                            <TabPanel header="Sospensione in KO">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable 
                                        :value="state.pdrSospKo"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                        <Column field="nota" header="Nota" style="width: 250px;" sortable>
                                            <template #body="slotProps">
                                                <span 
                                                    v-if="slotProps.data.nota" 
                                                    :title="slotProps.data.nota"
                                                    style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                >
                                                    {{ truncateText(slotProps.data.nota, 40) }}
                                                </span>
                                                <span v-else class="text-500">
                                                    Nessuna nota
                                                </span>
                                            </template>
                                        </Column>
                                        <Column header="Azioni" style="width: 120px;">
                                            <template #body="slotProps">
                                                <Button
                                                    icon="pi pi-comment"
                                                    class="p-button-sm p-button-rounded"
                                                    :class="slotProps.data.nota ? 'p-button-warning' : 'p-button-secondary'"
                                                    @click="openNoteModal(slotProps.data)"
                                                />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>

                            <TabPanel header="Riattivazione Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvSospensioniRiattivazioniPdr('riattivazioni')" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :value="state.riattivazioniRichiestePdr"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivazione Lavorazione">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable
                                        :value="state.riattivazioniLavorazionePdr"
                                        :paginator="true" 
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        :rowClass="riattivazioneLavorazioneColor"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="data_riattivazione_lavorazione" header="Data Riattivazione Lavorazione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                        <Column field="appuntamento" header="Appuntamento" style="width: 250px;" sortable>
                                            <template #body="slotProps">
                                                <span
                                                    v-if="slotProps.data.appuntamento"
                                                    :title="slotProps.data.appuntamento"
                                                    style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                >
                                                    {{ truncateText(slotProps.data.appuntamento, 40) }}
                                                </span>
                                                <span v-else class="text-500">
                                                    Nessun appuntamento
                                                </span>
                                            </template>
                                        </Column>
                                        <Column header="Azioni" style="width: 120px;">
                                            <template #body="slotProps">
                                                <Button
                                                    icon="pi pi-comment"
                                                    class="p-button-sm p-button-rounded"
                                                    :class="slotProps.data.appuntamento ? 'p-button-warning' : 'p-button-secondary'"
                                                    @click="openNoteModal(slotProps.data, 'appuntamento')"
                                                />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Riattivati">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button
                                            label="Cambia Stato"
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2"
                                            @click="cambiaStato()"
                                        ></Button>
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable
                                        :value="state.pdrRiattivati"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                    </DataTable>
                                </div>
                            </TabPanel>

                            <TabPanel header="Riattivazione in KO">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        ></Button>
                                    </div>
                                    
                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <i class="pi pi-exclamation-triangle pre-sosp-riatt-icon"></i>
                                            <span class="text-sm ml-2">Presente in preview rilascio tutela</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>


                                    <DataTable 
                                        :value="state.pdrRiatKo"
                                        :paginator="true"
                                        v-model:rows="state.rows"
                                        :rowsPerPageOptions="[10, 25, 50, 100]"
                                        :scrollable="true"
                                        v-model:filters="filters"
                                        :selection="state.changeTypeStateItems"
                                        @update:selection="onSelectionChange"
                                        v-if="!state.loading"
                                    >

                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText v-model="filters['global'].value" placeholder="Global Search" />
                                            </IconField>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column header="" :headerStyle="{ width: '3rem' }" :bodyStyle="{ textAlign: 'center' }">
                                            <template #body="slotProps">
                                                <i
                                                    v-if="hasPreSospRiatt(slotProps.data)"
                                                    class="pi pi-exclamation-triangle pre-sosp-riatt-icon"
                                                    v-tooltip.top="'Presente in preview rilascio tutela'"
                                                />
                                            </template>
                                        </Column>
                                        <Column field="code" header="Codice Pdr" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                        <Column field="motivazione" header="Motivazione" style="width: 200px;" sortable />
                                        <Column field="consecutivo" header="Consecutivo" style="width: 200px;" sortable />
                                        <Column field="stato_tutela" header="Stato Tutela" style="width: 200px;" sortable />
                                        <Column field="nota" header="Nota" style="width: 250px;" sortable>
                                            <template #body="slotProps">
                                                <span 
                                                    v-if="slotProps.data.nota" 
                                                    :title="slotProps.data.nota"
                                                    style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                >
                                                    {{ truncateText(slotProps.data.nota, 40) }}
                                                </span>
                                                <span v-else class="text-500">
                                                    Nessuna nota
                                                </span>
                                            </template>
                                        </Column>
                                        <Column header="Azioni" style="width: 120px;">
                                            <template #body="slotProps">
                                                <Button
                                                    icon="pi pi-comment"
                                                    class="p-button-sm p-button-rounded"
                                                    :class="slotProps.data.nota ? 'p-button-warning' : 'p-button-secondary'"
                                                    @click="openNoteModal(slotProps.data)"
                                                />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </AccordionTab>
            </Accordion>
        </div>

        <div id="cambia_stato_div">
            <Dialog 
                :visible="state.showCambiaStatoDialog" 
                :closable="false"
                modal 
                :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
                :style="{ width: '70vw' }" 
                >
                <template #header>
                    <div class="w-full text-center">
                        <h3>Cambia Stato</h3>
                    </div>
                </template>
                <div class="flex justify-content-around align-items-center p-4">
                    <div class="flex-child-left w-6 p-2">
                        <div class="w-full text-center p-2">
                            <h4>POD / PDR</h4>
                        </div>
                        <div v-if="state.changeTypeStateItems.length == 0">
                            <div class="flex justify-content-center align-items-center p-2">
                                <span>Nessun POD / PDR selezionato</span>
                            </div>
                        </div>
                        <div>
                            <VirtualScroller 
                            :items="state.changeTypeStateItems" 
                            :item-size="50" 
                            :style="{ height: '350px', width: '100%' }"
                            >
                            <template #item="slotProps">
                                <div class="flex justify-content-between align-items-center p-2 border-bottom">
                                    <span>{{ slotProps.item.code }}</span>
                                    <Button 
                                        :label="'X'" 
                                        :id="'button-' + slotProps.item.code" 
                                        @click="eliminaPodPdrDaElenco(slotProps.item.code)"
                                        class="p-button-danger"
                                        :title="'Elimina l\'elemnto ' + slotProps.item.code + ' dalla lista'"
                                        />
                                </div>
                            </template>
                            </VirtualScroller>
                        </div>
                    </div>
                    <div class="flex-child-right h-350px w-6 p-2">
                        <div class="w-full text-center p-2">
                            <label for="type_state_dropdown">Scegli lo stato fornitura:</label>
                            <Dropdown 
                                name="type_state_dropdown"
                                :options="state.type_state_options"
                                v-model="state.prossimoStato"
                                optionLabel="name"
                                placeholder="Scegli stato"
                                class="w-full mt-2"
                                />
                        </div>
                    </div>
                </div>

                <template #footer>

                    <Button
                    label="Conferma"
                    icon="pi pi-check"
                    @click="cambiaStatoConferma()"
                    class="p-button-success"
                />

                <Button
                    label="Chiudi"
                    icon="pi pi-times"
                    @click="state.showCambiaStatoDialog = false"
                    class="p-button-danger"
                    title="Chiudi la finestra"
                />
                </template>
            </Dialog>
        </div>

        <Dialog
            v-model:visible="state.noteDialogVisible"
            :header="state.noteMode === 'appuntamento' ? 'Appuntamento' : 'Nota'"
            :modal="true"
            :style="{ width: '600px' }"
        >
            <div v-if="state.selectedSupply">
                <p>
                    <strong>Fornitura:</strong>
                    {{ state.selectedSupply.code }}
                </p>

                <div v-if="state.selectedNote">
                    <p>
                        <strong>{{ state.noteMode === 'appuntamento' ? 'Appuntamento attuale:' : 'Nota attuale:' }}</strong>
                    </p>

                    <Textarea
                        v-model="state.noteForm.nota"
                        rows="5"
                        class="w-full"
                    />

                    <div class="mt-3 text-sm">
                        <p>
                            <strong>{{ state.noteMode === 'appuntamento' ? 'Creato da:' : 'Creata da:' }}</strong>
                            {{ state.selectedNote.created_by_name || '-' }}
                        </p>

                        <p>
                            <strong>{{ state.noteMode === 'appuntamento' ? 'Creato il:' : 'Creata il:' }}</strong>
                            {{ formatDataOra(state.selectedNote.creation_time) }}
                        </p>

                        <p v-if="state.selectedNote.updated_time">
                            <strong>{{ state.noteMode === 'appuntamento' ? 'Modificato da:' : 'Modificata da:' }}</strong>
                            {{ state.selectedNote.updated_by_name || '-' }}
                        </p>

                        <p v-if="state.selectedNote.updated_time">
                            <strong>Ultima modifica:</strong>
                            {{ formatDataOra(state.selectedNote.updated_time) }}
                        </p>
                    </div>
                </div>

                <div v-else>
                    <p>{{ state.noteMode === 'appuntamento' ? 'Non ci sono appuntamenti attivi per questa fornitura.' : 'Non ci sono note attive per questa fornitura.' }}</p>

                    <Textarea
                        v-model="state.noteForm.nota"
                        rows="5"
                        class="w-full"
                        :placeholder="state.noteMode === 'appuntamento' ? 'Inserisci un nuovo appuntamento' : 'Inserisci una nuova nota'"
                    />
                </div>
            </div>

            <template #footer>
                <Button
                    label="Annulla"
                    class="p-button-text"
                    @click="state.noteDialogVisible = false"
                />

                <Button
                    v-if="state.selectedNote"
                    :label="state.noteMode === 'appuntamento' ? 'Elimina appuntamento' : 'Elimina nota'"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="eliminaNota"
                />

                <Button
                    v-if="state.selectedNote"
                    :label="state.noteMode === 'appuntamento' ? 'Modifica appuntamento' : 'Modifica nota'"
                    icon="pi pi-save"
                    @click="aggiornaNota"
                />

                <Button
                    v-else
                    :label="state.noteMode === 'appuntamento' ? 'Aggiungi appuntamento' : 'Aggiungi nota'"
                    icon="pi pi-plus"
                    @click="aggiungiNota"
                />
            </template>
        </Dialog>
    </div>
</template>

<script>
    import { reactive, onMounted, getCurrentInstance, ref } from "vue";
    import { TabView, TabPanel } from "primevue/tabview";
    import { DataTable } from "primevue/datatable";
    import Service from "@/services/ask-admin/sosp-riat-service.js";
    import ProgressSpinner from "primevue/progressspinner";
    import Accordion from 'primevue/accordion';
    import AccordionTab from 'primevue/accordiontab';
    import Dialog from 'primevue/dialog';
    import VirtualScroller from 'primevue/virtualscroller';
    import { FilterMatchMode } from 'primevue/api';
    import { Column } from "primevue/column";

    export default {
        components: {
            TabView,
            TabPanel,
            DataTable,
            ProgressSpinner,
            Accordion,
            AccordionTab,
            Dialog,
            VirtualScroller,
            Column
        },
        setup() {

            const state = reactive({
                loadingButton: false,
                showCambiaStatoDialog: false,
                activeAccordionIndex: null,

                tabViewActiveIndex: 0,
                tabViewActiveIndexPdr: 0,

                sospensioniRichieste: [],
                sospensioniLavorazione: [],
                podSospesi: [],
                podSospKo: [],
                riattivazioniRichieste: [],
                riattivazioniLavorazione: [],
                podRiattivati: [],
                podRiatKo: [],
                podCostiSospensioni: [],
                podRiatSpostamento: [],

                sospensioniRichiestePdr: [],
                sospensioniLavorazionePdr: [],
                pdrSospesi: [],
                pdrSospKo: [],
                pdrRiatKo: [],
                riattivazioniRichiestePdr: [],
                riattivazioniLavorazionePdr: [],
                pdrRiattivati: [],

                rows: 50,
                sortField: 'id',
                sortOrder: 1,
                loading: false,
                changeTypeStateItems: [],
                type_state_options: [],
                prossimoStato: null,
                pagination: null,
                currentPage: 1,

                noteDialogVisible: false,
                noteMode: 'nota',
                selectedSupply: null,
                selectedNote: null,
                noteForm: {
                    nota: '',
                },
            });

            const filters = ref(
                {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            );

            const globalSearch = ref('');
            const globalSearchPdr = ref('');

            const { appContext } = getCurrentInstance();
            const $http = appContext.config.globalProperties.$http;
            const $eventBus = appContext.config.globalProperties.$eventBus;

            const service = new Service($http, $eventBus);

            const caricaStatiFornitura = async () => {
                try {
                    const response = await service.geTipiStatoFornituraSospensioniRiattivazioni();
                    state.type_state_options = response.items || [];
                } catch (error) {
                    console.error("Errore durante il caricamento degli stati della fornitura:", error);
                }
            }

            const cambiaStato = () => {
                state.showCambiaStatoDialog = true;
            }

            const onSelectionChange = (selection) => {
                state.changeTypeStateItems = selection;
            };

            const onTabChange = (event) => {
                state.tabViewActiveIndex = event.index;
                globalSearch.value = '';
                
                switch (event.index) {
                    case 0:
                        caricaRichiesteSospensione();
                        break;
                    case 1:
                        caricaSospensioneLavorazione();
                        break;
                    case 2:
                        caricaPodSospesi();
                        break;
                    case 3:
                        caricaPodSospensioniKo();
                        break;
                    case 4:
                        caricaRiattivazioniRichieste();
                        break;
                    case 5:
                        caricaRiattivazioniLavorazione();
                        break;
                    case 6:
                        caricaPodRiattivati();
                        break;
                    case 7:
                        caricaPodRiattivazioniKo();
                        break;
                    case 8:
                        caricaPodRiattivazioniSpostamento();
                        break;
                    case 9:
                        caricaPodCostiSospensione();
                        break;
                    default:
                        console.log("Nessuna azione per questa tab");
                }
            }

            const onTabChangePdr = (event) => {
                state.tabViewActiveIndexPdr = event.index;
                globalSearchPdr.value = '';
                
                switch (event.index) {
                    case 0:
                        caricaRichiesteSospensionePdr();
                        break;
                    case 1:
                        caricaSospensioneLavorazionePdr();
                        break;
                    case 2:
                        caricaPdrSospesi();
                        break;
                    case 3:
                        caricaPdrSospensioniKo();
                        break;
                    case 4:
                        caricaRiattivazioniRichiestePdr();
                        break;
                    case 5:
                        caricaRiattivazioniLavorazionePdr();
                        break;
                    case 6:
                        caricaPdrRiattivati();
                        break;
                    case 7:
                        caricaPdrRiattivazioniKo();
                        break;
                    default:
                        console.log("Nessuna azione per questa tab");
                }
            }

            const caricaRichiesteSospensione = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(21);
                    state.sospensioniRichieste = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle richieste sospensioni:", error);
                }
                state.loading = false;
            };

            const caricaSospensioneLavorazione = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(22);
                    state.sospensioniLavorazione = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle sospensioni in lavorazione:", error);
                }
                state.loading = false;
            };

            const caricaPodSospesi = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(18);
                    state.podSospesi = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod sospesi:", error);
                }
                state.loading = false;
            };

            const caricaPodSospensioniKo = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(25);
                    state.podSospKo = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod in sospensione in ko:", error);
                }
                state.loading = false;
            };

            const caricaRiattivazioniRichieste = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(23);
                    state.riattivazioniRichieste = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle richieste di riattivaizone:", error);
                }
                state.loading = false;
            };

            const caricaRiattivazioniLavorazione = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(24);
                    state.riattivazioniLavorazione = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle riattivazioni in lavorazione:", error);
                }
                state.loading = false;
            };

            const caricaPodRiattivati = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(19);
                    state.podRiattivati = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod riattivati:", error);
                }
                state.loading = false;
            };

            const caricaPodRiattivazioniKo = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(26);
                    state.podRiatKo = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod in riattivazione in ko:", error);
                }
                state.loading = false;
            };

            const caricaPodRiattivazioniSpostamento = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(20);
                    state.podRiatSpostamento = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod in riattivazione in ko:", error);
                }
                state.loading = false;
            };

            const caricaPodCostiSospensione = async () => {
                state.loading = true;
                try {
                    const response = await service.getPodByState(27);
                    state.podCostiSospensioni = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod con costi sospensione:", error);
                }
                state.loading = false;
            };

            // PDR

            const caricaRichiesteSospensionePdr = async () => {
                state.loading = true;
                try {
                    const response = await service.get_sospensione_richiesta_pdr();
                    state.sospensioniRichiestePdr = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle richieste sospensioni pdr:", error);
                }
                state.loading = false;
            };

            const caricaSospensioneLavorazionePdr = async () => {
                state.loading = true;
                try {
                    const response = await service.get_sospensione_lavorazione_pdr();
                    state.sospensioniLavorazionePdr = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle sospensioni in lavorazione pdr:", error);
                }
                state.loading = false;
            };

            const caricaPdrSospesi = async () => {
                state.loading = true;
                try {
                    const response = await service.get_pdr_sospesi();
                    state.pdrSospesi = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod sospesi pdr:", error);
                }
                state.loading = false;
            };

            const caricaRiattivazioniRichiestePdr = async () => {
                state.loading = true;
                try {
                    const response = await service.get_riattivazione_richiesta_pdr();
                    state.riattivazioniRichiestePdr = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle richieste di riattivaizone:", error);
                }
                state.loading = false;
            };

            const caricaRiattivazioniLavorazionePdr = async () => {
                state.loading = true;
                try {
                    const response = await service.get_riattivazione_lavorazione_pdr();
                    state.riattivazioniLavorazionePdr = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento delle riattivazioni in lavorazione:", error);
                }
                state.loading = false;
            };

            const caricaPdrRiattivati = async () => {
                state.loading = true;
                try {
                    const response = await service.get_pdr_riattivati();
                    state.pdrRiattivati = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pod riattivati:", error);
                }
                state.loading = false;
            };

            const caricaPdrSospensioniKo = async () => {
                state.loading = true;
                try {
                    const response = await service.get_pdr_sosp_ko();
                    state.pdrSospKo = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pdr in sospensione in ko:", error);
                }
                state.loading = false;
            };

            const caricaPdrRiattivazioniKo = async () => {
                state.loading = true;
                try {
                    const response = await service.get_pdr_riat_ko();
                    state.pdrRiatKo = elaborateResponse(response);
                } catch (error) {
                    console.error("Errore durante il caricamento dei pdr in riattivazione in ko:", error);
                }
                state.loading = false;
            };

            // fine pdr

            const elaborateResponse = (response) => {
                response.forEach(ele => {
                    const totaleFattura = parseFloat(ele.totale_fattura) || 0;
                    const pagato = parseFloat(ele.pagato) || 0;
                    const saldoUltimoMese = parseFloat(ele.saldo_ultimo_mese) || 0;

                    let saldo = totaleFattura - pagato;
                    ele.saldo = saldo > 0.001 ? saldo : 0;

                    ele.totale_fattura = Number(totaleFattura.toFixed(2));
                    ele.saldo_ultimo_mese = Number(saldoUltimoMese.toFixed(2));
                    ele.pagato = Number(pagato.toFixed(2));
                    ele.saldo = Number(ele.saldo.toFixed(2));
                });
                return response;
            }

            const cambiaStatoConferma = () => {

                let podIds = [];
                let pdrIds = [];
                state.changeTypeStateItems.forEach(ele => {
                    if (ele.code.toUpperCase().startsWith('IT')) {
                        podIds.push(ele.id);
                    } else {
                        pdrIds.push(ele.id);
                    }
                });

                service.cambiaStatoPodPdr(podIds, pdrIds, state.prossimoStato.id)
                    .then( () => {
                        state.showCambiaStatoDialog = false;
                        state.changeTypeStateItems = [];
                    })
                    .catch( error => {
                        console.error("Errore durante il cambio stato:", error);
                    });

                aggiornaTab();
            }

            const aggiornaTab = () => {
                switch (state.activeAccordionIndex) {
                    case 0:
                        switch (state.tabViewActiveIndex) {
                            case 0:
                                caricaRichiesteSospensione();
                                break;
                            case 1:
                                caricaSospensioneLavorazione();
                                break;
                            case 2:
                                caricaPodSospesi();
                                break;
                            case 3:
                                caricaPodSospensioniKo();
                                break;
                            case 4:
                                caricaRiattivazioniRichieste();
                                break;
                            case 5:
                                caricaRiattivazioniLavorazione();
                                break;
                            case 6:
                                caricaPodRiattivati();
                                break;
                            case 7:
                                caricaPodRiattivazioniKo();
                                break;
                            case 8:
                                caricaPodRiattivazioniSpostamento();
                                break;
                            case 9:
                                caricaPodCostiSospensione();
                                break;
                            default:
                                console.log("Nessuna azione per questa tab");
                        }
                        break;
                    case 1:
                        switch (state.tabViewActiveIndexPdr) {
                            case 0:
                                caricaRichiesteSospensionePdr();
                                break;
                            case 1:
                                caricaSospensioneLavorazionePdr();
                                break;
                            case 2:
                                caricaPdrSospesi();
                                break;
                            case 3:
                                caricaPdrSospensioniKo();
                                break;
                            case 4:
                                caricaRiattivazioniRichiestePdr();
                                break;
                            case 5:
                                caricaRiattivazioniLavorazionePdr();
                                break;
                            case 6:
                                caricaPdrRiattivati();
                                break;
                            case 7:
                                caricaPdrRiattivazioniKo();
                                break;
                            default:
                                console.log("Nessuna azione per questa tab");
                        }
                        break;
                    default:
                        console.log("Nessuna tab da aggiornare");
                }
            }

            const eliminaPodPdrDaElenco = (code) => {
                let index = state.changeTypeStateItems.findIndex( ele => ele.code == code);
                state.changeTypeStateItems.splice(index, 1);
            }

            const onAccordionChange = (index) => {
                state.activeAccordionIndex = index;
                if (index === 0) {
                    console.log('Il tab POD è stato aperto');
                    state.tabViewActiveIndex = 0;
                    caricaRichiesteSospensione();
                } else if (index === 1) {
                    console.log('Il tab PDR è stato aperto');
                    state.tabViewActiveIndexPdr = 0;
                    caricaRichiesteSospensionePdr();
                }
            }

            const generaCsvSospensioniRiattivazioni = async (type) => {
                state.loadingButton = true;
                let podsSospensioni = state.sospensioniRichieste;
                let podsRiattivazioni = state.riattivazioniRichieste;
                let podsSospensioneKO = state.podSospKo;
                let podsRiattivazioneKO = state.podRiatKo;


                if (type == 'sospensioni' && podsSospensioni.length > 0) {

                    let podIds = [];
                    podsSospensioni.forEach( pod => {
                        podIds.push(pod.id);
                    });


                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPod(podIds, "sospensioni", true);
                        if (response == 'ok') {
                            caricaRichiesteSospensione();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }

                } else if (type == 'riattivazioni' && podsRiattivazioni.length > 0) {

                    let podIds = [];
                    podsRiattivazioni.forEach( pod => {
                        podIds.push(pod.id);
                    });


                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPod(podIds, "riattivazioni", true);
                        if (response == 'ok') {
                            caricaRiattivazioniRichieste();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }

                } else if (type == 'sospKO' && podsSospensioneKO.length > 0) {

                    let podIds = [];
                    podsSospensioneKO.forEach( pod => {
                        podIds.push(pod.id);
                    });

                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPod(podIds, "sospensioni", false);
                        if (response == 'ok') {
                            // caricaPodSospensioniKo();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }
                } else if (type == 'riatKO' && podsRiattivazioneKO.length > 0) {

                    let podIds = [];
                    podsRiattivazioneKO.forEach( pod => {
                        podIds.push(pod.id);
                    });

                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPod(podIds, "riattivazioni", false);
                        if (response == 'ok') {
                            // caricaPodRiattivazioniKo();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }
                } else {
                    alert("Non ci sono POD");
                }

                state.loadingButton = false;
            };

            const generaCsvSospensioniRiattivazioniPdr = async (type) => {

                state.loadingButton = true;
                let pdrsSospensioni = state.sospensioniRichiestePdr;
                let pdrsRiattivazioni = state.riattivazioniRichiestePdr;


                if (type == 'sospensioni' && pdrsSospensioni.length > 0) {

                    let pdrIds = [];
                    pdrsSospensioni.forEach( pdr => {
                        pdrIds.push(pdr.id);
                    });


                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPdr(pdrIds, "sospensioni");
                        if (response == 'ok') {
                            caricaRichiesteSospensionePdr();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }

                } else if (type == 'riattivazioni' && pdrsRiattivazioni.length > 0) {

                    let pdrIds = [];
                    pdrsRiattivazioni.forEach( pdr => {
                        pdrIds.push(pdr.id);
                    });


                    try {
                        const response = await service.generazioneCsvSospensioniRiattivazioniPdr(pdrIds, "riattivazioni");
                        if (response == 'ok') {
                            caricaRiattivazioniRichiestePdr();
                        }
                    } catch (err) {
                        console.error("Errore durante la generazione del file CSV.", err);
                        state.loadingButton = false;
                    }

                } else {
                    alert("Non ci sono PDR");
                }

                state.loadingButton = false;
            }

            const hasPreSospRiatt = (data) => {
                const value = data?.exist_pre_sosp_riatt;
                return value === 1 || value === '1' || value === true;
            };

            const sospensioneLavorazioneColor = (data) => {
                const dataStr = data.data_sospensione_lavorazione;

                if (!dataStr) return '';

                const sospensione = new Date(dataStr);
                const oggi = new Date();

                sospensione.setHours(0, 0, 0, 0);
                oggi.setHours(0, 0, 0, 0);

                const diffTime = oggi - sospensione;
                const diffGiorni = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                if (diffGiorni <= 7) {
                    return '';
                } else if (diffGiorni <= 14) {
                    return 'row-light-yellow';
                } else if (diffGiorni <= 30) {
                    return 'row-light-orange';
                } else if (diffGiorni <= 60) {
                    return 'row-light-brown';
                } else {
                    return 'row-danger';
                }
            };

            const riattivazioneLavorazioneColor = (data) => {
                const dataStr = data.data_riattivazione_lavorazione;

                if (!dataStr) return '';

                const sospensione = new Date(dataStr);
                const oggi = new Date();

                sospensione.setHours(0, 0, 0, 0);
                oggi.setHours(0, 0, 0, 0);

                const diffTime = oggi - sospensione;
                const diffGiorni = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                if (diffGiorni <= 7) {
                    return '';
                } else if (diffGiorni <= 14) {
                    return 'row-light-yellow';
                } else if (diffGiorni <= 30) {
                    return 'row-light-orange';
                } else if (diffGiorni <= 60) {
                    return 'row-light-brown';
                } else {
                    return 'row-danger';
                }
            };

            function openNoteModal(row, mode = 'nota') {
                state.selectedSupply = row;
                state.noteMode = mode;

                state.selectedNote = mode === 'appuntamento'
                    ? (row.appuntamento_id
                        ? {
                            id: row.appuntamento_id,
                            nota: row.appuntamento,
                            created_by: row.appuntamento_created_by,
                            created_by_name: row.appuntamento_created_by_name,
                            creation_time: row.appuntamento_creation_time,
                            updated_by: row.appuntamento_updated_by,
                            updated_by_name: row.appuntamento_updated_by_name,
                            updated_time: row.appuntamento_updated_time,
                        }
                        : null)
                    : (row.nota_id
                        ? {
                            id: row.nota_id,
                            nota: row.nota,
                            created_by: row.nota_created_by,
                            created_by_name: row.nota_created_by_name,
                            creation_time: row.nota_creation_time,
                            updated_by: row.nota_updated_by,
                            updated_by_name: row.nota_updated_by_name,
                            updated_time: row.nota_updated_time,
                        }
                        : null);

                state.noteForm.nota = state.selectedNote ? state.selectedNote.nota : '';
                state.noteDialogVisible = true;
            }

            function getSupplyType(row) {
                return row.code.startsWith('IT') ? 'pod' : 'pdr';
            }

            function getSupplyStateNote(row) {
                return row.supply_state_note ?? row.cod_type_state ?? row.pp_state ?? 25;
            }

            async function aggiungiNota() {
                if (!state.selectedSupply || !state.noteForm.nota.trim()) {
                    return;
                }

                const payload = {
                    supply_code: state.selectedSupply.code,
                    nota: state.noteForm.nota,
                    supply_state_note: getSupplyStateNote(state.selectedSupply),
                };

                const response = state.noteMode === 'appuntamento'
                    ? await service.aggiungiAppuntamentoSospensioneRiattivazione(payload)
                    : await service.aggiungiNotaSospensioneRiattivazione(payload);

                if (response?.success) {
                    state.noteDialogVisible = false;
                    aggiornaTab();
                }
            }

            async function aggiornaNota() {
                const payload = {
                    id: state.selectedNote.id,
                    nota: state.noteForm.nota,
                };

                const response = state.noteMode === 'appuntamento'
                    ? await service.aggiornaAppuntamentoSospensioneRiattivazione(payload)
                    : await service.aggiornaNotaSospensioneRiattivazione(payload);

                if (response?.success) {
                    state.noteDialogVisible = false;
                    aggiornaTab();
                }
            }

            async function eliminaNota() {
                const payload = {
                    supply_id: state.selectedSupply.id,
                    supply_type: getSupplyType(state.selectedSupply),
                    supply_state: getSupplyStateNote(state.selectedSupply),
                };

                const response = state.noteMode === 'appuntamento'
                    ? await service.eliminaAppuntamentoSospensioneRiattivazione(payload)
                    : await service.eliminaNotaSospensioneRiattivazione(payload);

                if (response?.success) {
                    state.noteDialogVisible = false;
                    aggiornaTab();
                }
            }

            // "YYYY-MM-DD HH:mm:ss" dal DB -> "DD/MM/YYYY HH:mm", senza passare da Date per non spostare il fuso
            function formatDataOra(value) {
                if (!value) return '-';
                const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
                return match ? `${match[3]}/${match[2]}/${match[1]} ${match[4]}:${match[5]}` : value;
            }

            function truncateText(text, length = 40) {
                if (!text) return '';
                return text.length > length ? text.substring(0, length) + '...' : text;
            }

            onMounted(() => {
                caricaStatiFornitura();
            });

            return {
                pageName: "Sospensione / Riattivazione",
                state,
                onAccordionChange,
                onTabChange,
                onTabChangePdr,
                elaborateResponse,
                cambiaStato,
                onSelectionChange,
                eliminaPodPdrDaElenco,
                cambiaStatoConferma,
                globalSearch,
                globalSearchPdr,
                generaCsvSospensioniRiattivazioni,
                generaCsvSospensioniRiattivazioniPdr,
                hasPreSospRiatt,
                riattivazioneLavorazioneColor,
                sospensioneLavorazioneColor,
                filters,
                caricaRichiesteSospensione,
                caricaSospensioneLavorazione,
                caricaRiattivazioniRichieste,
                caricaRiattivazioniLavorazione,
                caricaPodSospesi,
                caricaPodRiattivati,
                caricaPodRiattivazioniSpostamento,
                caricaRichiesteSospensionePdr,
                caricaSospensioneLavorazionePdr,
                caricaPdrSospesi,
                caricaPdrRiattivati,
                caricaPdrSospensioniKo,
                caricaPdrRiattivazioniKo,
                openNoteModal,
                aggiungiNota,
                aggiornaNota,
                eliminaNota,
                truncateText,
                formatDataOra,
            };
        }
    }
</script>

<style>
    .custom-tabview .p-tabview-nav {
        display: flex;
        width: 100%;
    }

    .custom-tabview .p-tabview-nav li {
        flex: 1; 
        text-align: center; 
    }

    .custom-tabview .p-tabview-nav li a {
        width: 100%; 
        display: block; 
    }

    .custom-sub-title {
        width: 100%; 
        text-align: center;
    }

    #data_table-div {
        padding: 2%;
    }

    #page-title {
        width: 100%;
        text-align: center;
    }

    .row-light-yellow {
        background-color: #fff200 !important; /* Giallo intenso */
    }

    .row-light-orange {
        background-color: #ffae42 !important; /* Arancione medio */
    }

    .row-light-brown {
        background-color: #ff7b00 !important; /* Arancione scuro / Marrone acceso */
    }

    .row-danger {
        background-color: #ff4c4c !important; /* Rosso vivido */
    }

    .pre-sosp-riatt-icon {
        color: #f44336;
        font-size: 1.1rem;
        flex-shrink: 0;
    }

    .color-box {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 4px;
        border: 1px solid #ccc;
    }

</style>